import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ComingSoonModal from "@components/modals/ComingSoonModal";

export default function LaunchpadPage() {
  const [open, setOpen] = useState(true); // auto buka saat page load
  const navigate = useNavigate();

  const closeAndBack = () => {
    setOpen(false);
    // opsional: balik ke halaman sebelumnya
    try {
      navigate(-1);
    } catch {
      navigate("/");
    }
  };

  return (
    <main className="pt-[5.5rem] lg:pt-24">
      <ComingSoonModal open={open} onClose={closeAndBack} />

      {/* Isi placeholder (tidak akan terlihat karena modal muncul duluan) */}
      <section className="px-6 py-16">
        <h1 className="font-display text-3xl text-white">Launchpad</h1>
        <p className="mt-2 text-jacarta-300">
          Halaman ini akan tersedia segera.
        </p>
      </section>
    </main>
  );
}
